import { computed, inject, Injector } from '@angular/core';
import {
  signalStore,
  withComputed,
  withMethods,
  withProps,
  withState,
} from '@ngrx/signals';
import {
  Energy_Village__Stato_Cer_Enum,
  GetTipologieAssetGQL,
} from '../../../_core/_graphql/generated';
import { initialTipologiaAssetState } from './tipologia_asset.state';
import { getTipologiaAsset } from './tipologia_asset.utility';

export const TipologiaAssetStore = signalStore(
  { providedIn: 'root' },
  withState(initialTipologiaAssetState),
  withProps(() => ({
    getter: inject(GetTipologieAssetGQL),
  })),
  withComputed(({ lista }) => ({
    lista_prosumer: computed(() =>
      lista().filter((el) => el.tipologia == 'prosumer'),
    ),
    lista_founder: computed(() => {
      const founders = lista().filter((el) => el.tipologia === 'founder');

      const [founder] = founders;

      return [
        {
          ...founder,
          route: `${Energy_Village__Stato_Cer_Enum.Iniziativa}`,
          icon: 'j4g-initiativa',
          label: 'iniziativa',
          order: 2,
        },
        {
          ...founder,
          route: `${Energy_Village__Stato_Cer_Enum.Attiva}`,
          icon: 'j4g-attiva',
          label: 'attiva',
          order: 1,
        },
      ];
    }),
  })),
  withMethods(({ getter, ...store }, injector = inject(Injector)) => ({
    init: getTipologiaAsset(injector, store, getter),
  })),
);
